export default __webpack_public_path__ + "static/computer-178fd3d1c1ab5dc0c43b2214eca89362.png";